import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IDeleteFlowsParams {
  ids: string[];
}

export interface IDeleteFlowsResult extends IResult {
}

export class DeleteFlowsRequest extends Request<IDeleteFlowsParams, IDeleteFlowsResult> {
  constructor(ids: string[]) {
    super('deleteFlows', { ids: ids });
  }
}


